var exports = {
  "W": "xaf9ae18d--48c0ed--dropdown",
};

module.exports = exports;
